import {
  AutoAwesomeMotion,
  Person,
  ExitToApp,
  HelpOutline,
  Home,
  Logout,
  Password,
  QrCode,
  Assignment,
  AssignmentTurnedIn,
  Medication,
  Help,
  CancelPresentation,
  Print,
  FactCheck,
  WhatsApp,
} from '@mui/icons-material';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PostAddIcon from '@mui/icons-material/PostAdd';
import BiotechIcon from '@mui/icons-material/Biotech';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export const SideMenuList = [
  {
    to: '/',
    label: 'Inicio',
    icon: <Home />,
  },
  {
    label: 'Orden Electrónica',
    icon: <QrCode />,
    submenu: [
      {
        to: '/orden-digital',
        label: 'Generar Orden de Consulta',
        icon: <QrCode />,
      },
      {
        to: '/orden-digital-practica',
        label: 'Generar Orden de Práctica',
        icon: <BiotechIcon />,
      },
      {
        to: '/validar-orden',
        label: 'Validar Orden',
        icon: <FactCheckOutlinedIcon />,
      },
      {
        to: '/adjuntar-informes',
        label: 'Adjuntar Informes',
        icon: <CloudUploadIcon />,
      },
      {
        to: '/consultar-ordenes-electronicas',
        label: 'Consultar Orden',
        icon: <ManageSearchIcon />,
      },
      {
        to: '/anular-orden-electronica',
        label: 'Anular Orden',
        icon: <DeleteSweepOutlinedIcon />,
      },
    ],
  },
  {
    label: 'Orden Impresa',
    icon: <Assignment />,
    submenu: [
      {
        to: '/orden-consulta',
        label: 'Generar Orden de Consulta',
        icon: <Assignment />,
      },
      {
        to: '/orden-varia',
        label: 'Generar Orden de Prácticas',
        icon: <PostAddIcon />,
      },
      {
        to: '/consultar-ordenes-impresas',
        label: 'Consultar Orden',
        icon: <ManageSearchIcon />,
      },
      {
        to: '/reimpresion-orden',
        label: 'Reimpresión',
        icon: <Print />,
      },
      {
        to: '/registrar-atencion',
        label: 'Registrar Atención',
        icon: <AssignmentTurnedIn />,
      },
      {
        to: '/anular-atencion',
        label: 'Anular Atención',
        icon: <CancelPresentation />,
      },
      {
        to: '/consultar-cupo',
        label: 'Consultar Cupo',
        icon: <AutoAwesomeMotion />,
      },
      {
        to: '/anular-orden-impresa',
        label: 'Anular Orden',
        icon: <DeleteSweepOutlinedIcon />,
      },
      {
        to: '/validar-orden',
        label: 'Validar Orden',
        icon: <FactCheckOutlinedIcon />,
      },
      {
        to: '/adjuntar-informes',
        label: 'Adjuntar Informes',
        icon: <CloudUploadIcon />,
      },
    ],
  },
];

export const SideMenuListOdontologos = [
  {
    to: '/',
    label: 'Inicio',
    icon: <Home />,
  },
  {
    label: 'Orden Impresa',
    icon: <Assignment />,
    submenu: [
      {
        to: '/orden-consulta',
        label: 'Generar Orden de Consulta',
        icon: <Assignment />,
      },
      {
        to: '/consultar-ordenes-impresas',
        label: 'Consultar Orden',
        icon: <ManageSearchIcon />,
      },
      {
        to: '/reimpresion-orden',
        label: 'Reimpresión',
        icon: <Print />,
      },
      {
        to: '/registrar-atencion',
        label: 'Registrar Atención',
        icon: <AssignmentTurnedIn />,
      },
      {
        to: '/anular-atencion',
        label: 'Anular Atención',
        icon: <CancelPresentation />,
      },
      {
        to: '/consultar-cupo',
        label: 'Consultar Cupo',
        icon: <AutoAwesomeMotion />,
      },
      {
        to: '/anular-orden-impresa',
        label: 'Anular Orden',
        icon: <DeleteSweepOutlinedIcon />,
      },
      {
        to: '/validar-orden',
        label: 'Validar Orden',
        icon: <FactCheckOutlinedIcon />,
      },
      {
        to: '/adjuntar-informes',
        label: 'Adjuntar Informes',
        icon: <CloudUploadIcon />,
      },
    ],
  },
];

export const SideMenuListOptica = [
  {
    to: '/',
    label: 'Inicio',
    icon: <Home />,
  },
  {
    label: 'Orden Impresa',
    icon: <Assignment />,
    submenu: [
      // {
      //   to: '/orden-varia',
      //   label: 'Generar Orden Varias',
      //   icon: <PostAddIcon />,
      // },
      // {
      //   to: '/consultar-ordenes-impresas',
      //   label: 'Consultar Orden',
      //   icon: <ManageSearchIcon />,
      // },
      // {
      //   to: '/reimpresion-orden',
      //   label: 'Reimpresión',
      //   icon: <Print />,
      // },
      {
        to: '/registrar-atencion',
        label: 'Registrar Atención',
        icon: <AssignmentTurnedIn />,
      },
      {
        to: '/anular-atencion',
        label: 'Anular Atención',
        icon: <CancelPresentation />,
      },
      {
        to: '/consultar-cupo',
        label: 'Consultar Cupo',
        icon: <AutoAwesomeMotion />,
      },
      // {
      //   to: '/anular-orden-impresa',
      //   label: 'Anular Orden',
      //   icon: <DeleteSweepOutlinedIcon />,
      // },
    ],
  },
];

export const SideMenuListProfesional = [
  {
    label: 'Receta Electrónica',
    icon: <Medication />,
    submenu: [
      {
        to: '/generar-receta',
        label: 'Generar Receta',
        icon: <Medication />,
      },
      /*{
        to: '/generar-receta-especiales',
        label: 'Generar Receta Crónicos',
        icon: <Medication />,
      },*/
      {
        to: '/consultar-recetas',
        label: 'Consultar Recetas',
        icon: <ManageSearchIcon />,
      },
    ],
  },
  {
    label: 'Prescripción Electrónica',
    icon: <Medication />,
    submenu: [
      {
        to: '/generar-prescripcion-electronica',
        label: 'Generar Prescripción',
        icon: <Medication />,
      },
      {
        to: '/consultar-prescripciones-electronicas',
        label: 'Consultar Prescripciones',
        icon: <ManageSearchIcon />,
      },
    ],
  },
  {
    label: 'Solicitud de Autorización',
    icon: <FactCheck />,
    submenu: [
      {
        to: '/autorizaciones',
        label: 'Generar Solicitud',
        icon: <PostAddIcon />,
      },
      {
        to: '/consultar-autorizaciones',
        label: 'Consultar Solicitud',
        icon: <ManageSearchIcon />,
      },
    ],
  },
];

export const SideMenuListProfesionalBioquimico = [
  {
    label: 'Prescripción Electrónica',
    icon: <Medication />,
    submenu: [
      {
        to: '/generar-prescripcion-electronica',
        label: 'Generar Prescripción',
        icon: <Medication />,
      },
      {
        to: '/consultar-prescripciones-electronicas',
        label: 'Consultar Prescripciones',
        icon: <ManageSearchIcon />,
      },
    ],
  },
];

export const SideMenuListNoProfesional = [];

export const BottomMenuList = [
  {
    to: '/signout',
    label: 'Salir',
    icon: <ExitToApp />,
  },
];

export const BottomMenuListAyuda = [
  {
    to: '/ayuda',
    label: 'Ayuda',
    icon: <Help />,
  },
  {
    to: 'https://wa.me/5493435325271',
    label: 'Mesa de Ayuda',
    icon: <WhatsApp />,
    external: true,
  },
];

export const TopMenuList = [
  {
    to: '/perfil',
    icon: <Person fontSize='small' />,
    label: 'Perfil',
  },
  {
    to: '/cambiar-password',
    label: 'Cambiar mi Contraseña',
    icon: <Password fontSize='small' />,
  },
  {
    to: '/terminos-condiciones',
    label: 'Términos y condiciones',
    icon: <HelpOutline fontSize='small' />,
  },
  {
    to: '/signout',
    label: 'Salir',
    icon: <Logout fontSize='small' />,
  },
];
